import { ToggleFilterCallback } from './GalleryFilter';
import Filter from '../../components/Filter';
import { ColorFilter } from '@root/src/partials/visualizer';

interface GalleryFilterItemProps {
  title: string;
  items: string[];
  itemFilters: string[];
  toggleStyleFilters: ToggleFilterCallback;
  colorLabels?: boolean;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & GalleryFilterItemProps>;

const GalleryFilterItem: Props = ({ title, items, itemFilters, toggleStyleFilters, colorLabels = false, ...props }) => (
  <div className="col-span-12 sm:col-span-4" {...props}>
    <p className="text-sm text-gray-darker">{title}</p>

    <hr className="my-8 border-gray sm:my-16" />

    <div className="grid grid-cols-3 gap-8 sm:grid-cols-2">
      {items.map((item) => (
        <Filter
          id={`${item}FilterBtn`}
          key={item}
          onClick={() => {
            toggleStyleFilters(item);
          }}
          isActive={itemFilters.includes(item)}
          filterColor={colorLabels ? (item as ColorFilter) : undefined}
          filterLabel={item
            .split(' ')
            .map((x) => x.charAt(0).toUpperCase() + x.substr(1).toLowerCase())
            .join(' ')}
        />
      ))}
    </div>
  </div>
);

export default GalleryFilterItem;
